<template>
  <b-table
    :loading="isLoading"
    :data="rows"
    paginated
    :per-page="30"
    striped
    pagination-size="is-small"
    :row-class="getRowClass"
  >
    <b-table-column
      v-slot="props"
      field="id"
      label="ID"
      numeric
      header-class="header-custom"
      cell-class="cell-custom"
    >
      <h1 class="table-title">
        {{ props.row.id }}
      </h1>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="descricao"
      label="Descrição"
      header-class="header-custom"
      cell-class="cell-custom"
    >
      <h1>{{ props.row.descricao }}</h1>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="ean"
      label="EAN"
      header-class="header-custom"
      cell-class="cell-custom"
    >
      <span class="tag is-default-tag">
        <h1 class="ean">{{ props.row.ean }}</h1>
      </span>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="idproduto"
      label="ID Produto"
      centered
      header-class="header-custom"
      cell-class="cell-custom"
    >
      <h1 class="table-title">
        {{ props.row.produto_id }}
      </h1>
    </b-table-column>

    <b-table-column
      v-slot="props"
      label="Quantidade"
      centered
      header-class="header-custom"
      cell-class="cell-custom"
    >
      <h1 class="table-title">
        {{ props.row.qtdpedida }}
      </h1>
    </b-table-column>

    <b-table-column
      v-slot="props"
      label="Acréscimo"
      centered
      header-class="header-custom"
      cell-class="cell-custom"
    >
      <h1 class="table-title">
        {{ transformToBrl(props.row.vlracrescimo) }}
      </h1>
    </b-table-column>

    <b-table-column
      v-slot="props"
      label="Desconto"
      centered
      header-class="header-custom"
      cell-class="cell-custom"
    >
      <h1 class="table-title">
        {{ transformToBrl(props.row.vlrdesconto) }}
      </h1>
    </b-table-column>
    <b-table-column
      v-slot="props"
      label="Valor"
      centered
      header-class="header-custom"
      cell-class="cell-custom"
    >
      <h1 class="table-title">
        {{ transformToBrl(props.row.vlrproduto) }}
      </h1>
    </b-table-column>
    <b-table-column
      v-slot="props"
      label="Valor Total"
      centered
      header-class="header-custom"
      cell-class="cell-custom"
    >
      <h1 class="table-title">
        {{ transformToBrl(props.row.vlrTotal) }}
      </h1>
    </b-table-column>
  </b-table>
</template>

<script>
import global from '../../../mixins/global';

export default {
	mixins: [global],
	props: {
		rows: {
			type: Array,
			default: () => [],
		},
		isLoading: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		getRowClass() {
			return 'custom-row-class';
		},
	},
};
</script>
<style lang="scss">
.cell-custom {
  font-size: 12px;
}
.ean {
  color: #fff;
}
.is-default-tag {
  background-color: #bfbffd !important;
}
.custom-row-class {
  transition: 0.3s ease-in-out;
}
.custom-row-class:hover {
  background-color: #f4f2ff;
  transform: scale(1.01);
  cursor: pointer;
}

.header-custom {
  font-size: $header-size;
  font-weight: $header-weight;
  color: $header-color;
}
.table-title {
  display: flex;
  color: $row-color;
  font-weight: $row-weight;
  margin-top: 2.5px;
  margin-bottom: 2.5px;
  font-size: $row-size;
}
</style>
